"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFontColor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extensionTextStyle = _interopRequireDefault(require("@tiptap/extension-text-style"));

var _constants = require("../toolbar/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CustomFontColor = _extensionTextStyle.default.extend({
  addAttributes: function addAttributes() {
    var _this$parent;

    return _objectSpread(_objectSpread({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
      class: {
        default: _constants.FONT_COLOR_DEFAULT_CLASS_NAME,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('class');
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes['class']) {
            return {};
          }

          return {
            class: attributes['class']
          };
        }
      },
      role: {
        default: null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('role');
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes['role']) {
            return {};
          }

          return {
            role: attributes['role']
          };
        }
      },
      'aria-roledescription': {
        default: null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('aria-roledescription');
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes['aria-roledescription']) {
            return {};
          }

          return {
            'aria-roledescription': attributes['aria-roledescription']
          };
        }
      },
      tabindex: {
        default: null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('tabindex');
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes['tabindex']) {
            return {};
          }

          return {
            tabindex: attributes['tabindex']
          };
        }
      }
    });
  }
});

exports.CustomFontColor = CustomFontColor;